module.exports = __webpack_public_path__ + "static/aquiles-e10cefee5eb81b1dcf9c427a8a6a3963.jpg";